import { useContext } from 'react';
import { toast } from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { ColorName } from 'types';

import { useAppSelector } from 'redux/hooks';

import { LayoutContext } from 'contexts';

import { routes } from 'data/routes';

import { Button } from 'components/Button';
import { Icon } from 'components/Icon';

import * as S from './Success.styles';

export function Success(): React.ReactElement {
  const navigate = useNavigate();

  const { isOrderModalVisibleSet } = useContext(LayoutContext);

  const { orderId, barColor } = useAppSelector((state) => state.settings);

  const { t } = useTranslation();

  return (
    <S.Container>
      <S.Title scale="xl3">
        <S.SuccessIcon>
          <Icon name="FiCheckCircle" size={28} color="green" />
        </S.SuccessIcon>{' '}
        {t('order.createdSuccessfully')}
      </S.Title>

      <S.Info fontFamily="LFT Zeno" fontWeight="extraLight" scale="s">
        {t('order.leavePageConfirm')}
      </S.Info>

      <S.Actions>
        <Button
          textTransform="isFirstLetterUppercase"
          fontFamily="LFT Zeno"
          fontWeight="light"
          motive="cancelTertiary"
          scale="s"
          onClick={() => isOrderModalVisibleSet(false)}
        >
          {t('order.stayOnPage')}
        </Button>

        <S.ButtonGo
          textTransform="isFirstLetterUppercase"
          fontFamily="LFT Zeno"
          motive="actionPrimary"
          barColor={barColor as ColorName}
          onClick={() => {
            if (!orderId) {
              toast.error('Order ID not available');
              return;
            }
            isOrderModalVisibleSet(false);
            navigate(routes.singleOrder(orderId));
          }}
        >
          {t('order.goToOrder')}
        </S.ButtonGo>
      </S.Actions>
    </S.Container>
  );
}
